'use client';

import React, { useEffect, useMemo , useState} from 'react';
import PropTypes from 'prop-types';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import SearchList from './SearchList';
import SearchMap from './SearchMap';

SearchResults.propTypes = {
    selectedAddress: PropTypes.shape({
        address: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
    radius: PropTypes.number,
    clinicData: PropTypes.array,
    previouslySelectedClinic: PropTypes.string,
};

const DEFAULT_ZOOM_LEVEL = 9;

export default function SearchResults({ selectedAddress, radius, clinicData, previouslySelectedClinic }) {
    const map = useMap();
    const [curTab, setCurTab] = useState('list');
    const [selectedClinic, setSelectedClinic] = useState(previouslySelectedClinic);

    useEffect(() => {
        if (map && selectedAddress?.lat && selectedAddress?.lng) {
            map.panTo({
                lat: selectedAddress.lat,
                lng: selectedAddress.lng,
            });
            map.setZoom(DEFAULT_ZOOM_LEVEL);
        }
    }, [selectedAddress, map]);

    const geometryLibrary = useMapsLibrary('geometry');
    const clinics = useMemo(() => clinicData, []);
    const filteredResults = useMemo(() => {
        if (!geometryLibrary) return [];
        const filteredClinics = clinics.filter((clinic) => {
            if (!Object.keys(selectedAddress).length) return false;
            const clinicLocation = {
                lat: clinic.lat,
                lng: clinic.lng,
            };
            const selectedAddressLocation = {
                lat: selectedAddress.lat,
                lng: selectedAddress.lng,
            };

            const { spherical } = geometryLibrary;
            const distance = spherical.computeDistanceBetween(
                selectedAddressLocation,
                clinicLocation
            );
            const distanceInMiles = Math.ceil(distance * 0.000621371192);

            clinic.distance = distanceInMiles;

            return distanceInMiles < radius;
        });

        const flagShipClinics = filteredClinics.filter((clinic) => {
            return clinic.flagship;
        });
        const nonFlagShipClinics = filteredClinics.filter((clinic) => {
            return !clinic.flagship;
        });

        flagShipClinics.sort((a, b) => a.distance - b.distance);
        nonFlagShipClinics.sort((a, b) => a.distance - b.distance);

        return flagShipClinics.concat(nonFlagShipClinics);
    }, [geometryLibrary, selectedAddress, radius]);

    function changeTab(e, tab) {
        e.preventDefault();
        setCurTab(tab)
    }

    function handleClinicSelect(clinic) {
        setSelectedClinic(clinic.id);
    }
    
    return (
        <section className="searchResultsWrapper">
            {Object.keys(selectedAddress).length > 0 && (
                <>
                    <div className="searchResultsWrapper__tabs">
                        <a href="#" className={`searchResultsWrapper__tab ${curTab == 'list' ? 'searchResultsWrapper__tab--active' : ''}`} onClick={(e)=>changeTab(e, 'list')}>List</a>
                        <a href="#" className={`searchResultsWrapper__tab ${curTab == 'map' ? 'searchResultsWrapper__tab--active' : ''}`} onClick={(e)=>changeTab(e, 'map')}>Map</a>
                    </div>
                
                    <div className={`searchResultsWrapper__grid ${selectedAddress ? '' : 'u-hidden'}`}>
                        <SearchList results={filteredResults} curTab={curTab} onSelect={handleClinicSelect} selectedClinic={selectedClinic} />
                        <SearchMap
                            selectedAddress={selectedAddress}
                            results={filteredResults}
                            curTab={curTab}
                            onSelect={handleClinicSelect}
                        />
                    </div>
                </>
            )}
        </section>
    );
}
